import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Profile from './views/Profile.vue';
import MCQ from './views/MCQ.vue';
import AreaLayout from '@/components/Layout.vue';
import ProgramSelect from './views/ProgramSelect.vue';
import MCQSubject from './views/MCQSubject.vue';
import Progress from './views/Progress.vue';
import VideosTopic from './views/VideosTopic.vue';
import VideosSubject from './views/VideosSubject.vue';
import PastPapers from './views/PastPapers.vue';
import QR from './views/QR.vue';
import PageNotFound from './views/PageNotFound.vue';
import AuthService from '@/services/auth-service';
import TestClassSelect from './views/TestClass.vue';
import TestPaper from './views/TestPapers.vue';
import PreModule from './views/PreModule.vue';
import PreModuleWork from './views/PreModuleWork.vue';
import PreResources from './views/PreResources.vue';
import PreCo from './views/PreCo.vue';
import Orientation from './views/Orientation.vue';
import LiteraryClub from './views/LiteraryClub.vue';
import Winners from './views/Winners.vue';
import SelectApp from './views/SelectApp.vue';
import SelectEL from './views/SelectEL.vue';
import SelectCMS from './views/SelectCMS.vue';
import Timetable from './views/Timetable.vue';
import Attendance from './views/Attendance.vue';
import ExamResult from './views/ExamResult.vue';
import Fees from './views/Fees.vue';
import NoticeBoard from './views/NoticeBoard.vue';
import TestSession from './views/TestSession.vue';
import TestSelect from './views/TestSelect.vue';
import MCQTypeSelect from './views/MCQTypeSelect.vue';
import CustomExam from './views/CustomExam.vue';
import AcademicCalendar from './views/AcademicCalendar.vue';
import AskQuestion from './views/AskQuestion.vue';
import StepLearning from './views/StepLearning.vue';
import TestResult from './views/TestResult.vue';
import LongShortType from './views/LongShortType.vue'
import TrainingCourses from "./views/trainingCourses.vue";
import TrainingModules from "./views/TrainingModules.vue";
import TraningVideos from "./components/TraningVideos.vue";
import config from './services/api-config';


Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: './',
  routes: [
    {
      component: QR,
      path: '/download',
      name: 'download',
    },
    {
      component: AreaLayout,
      path: '/',
      meta: {
        private: true,
        title: window.location.origin.toLowerCase().indexOf('hadaf') > -1 ? 'My Hadaf' : 'My PGC',
      },
      children: [
        {
          path: '/',
          name: 'home',
          component: Home,
        },
        {
          path: '/home',
          name: 'meh',
          component: PageNotFound,
        },
        {
          path: '/profile',
          name: 'profile',
          component: Profile,
          meta: {
            title: 'Profile'
          }
        },
        {
          path: '/pre-module',
          name: 'pre-module',
          component: PreModule,
        },
        {
          path: '/pre-co',
          name: 'pre-co',
          component: PreCo,
        },
        {
          path: '/pre-literary',
          name: 'pre-literary',
          component: LiteraryClub,
        },
        {
          path: '/pre-module-work/:day',
          name: 'pre-module-work',
          component: PreModuleWork,
        },
        {
          path: '/pre-resources',
          name: 'pre-resources',
          component: PreResources,
        },
        {
          path: '/test-result',
          name: 'testresult',
          component: TestResult
        },
        {
          path: '/test-session',
          name: 'test-session',
          component: TestSession,
        },
        {
          path: '/test-select',
          name: 'test-select',
          component: TestSelect,
        },
        {
          path: '/orientation',
          name: 'orientation',
          component: Orientation,
          meta: {
            title: 'Orientation'
          }
        },
        {
          path: '/askaquestion',
          name: 'ask-question',
          component: AskQuestion,
          meta: {
            title: 'Ask a Question'
          }
        },
        {
          path: "/trainingcourses",
          name: "trainingcourses",
          component: TrainingCourses,
          meta: {
            title: "Training Courses",
          },
        },
         {
          path: "/trainingmodules",
          name: "trainingmodules",
          component: TrainingModules,
          meta: {
            title: "Training Modules",
          },
        },
         {
          path: "/trainingvideo",
          name: "trainingvideo",
          component: TraningVideos,
          meta: {
            title: "Training Video",
          },
        },
        {
          path: '/academic-calendar',
          name: 'academic-calendar',
          component: AcademicCalendar,
          meta: {
            title: 'Academic Calendar'
          }
        },
        {
          path: '/quiz',
          name: 'quiz',
          component: MCQ,
        },
        {
          path: '/step-learning',
          name: 'step-learning',
          component: StepLearning,
          meta: {
            title: 'Step Learning'
          }
        },
        {
          path: '/customexam',
          name: 'customexam',
          component: CustomExam,
          meta: {
            title: 'Custom Practice Sheet'
          }
        },
        {
          path: '/longshortselect',
          name: 'longshortselect',
          component: LongShortType,
          meta: {
            title: 'Select Type'
          }
        },
        {
          path: '/noticeboard',
          name: 'notice',
          component: NoticeBoard,
          meta: {
            title: 'Notice Board'
          }
        },
        // {
        //   path: '/testclassselect',
        //   name: 'test-class-select',
        //   component: TestClassSelect,
        // },
        // {
        //   path: '/testpaper/:id/:name',
        //   name: 'test-paper',
        //   component: TestPaper,
        // },
        {
         path: '/selectApp',
         name: 'appselect',
         component: SelectApp,
         meta: {
          title: 'Home'
        }
        },
        {
          path: '/selectEL',
          name: 'elselect',
          component: SelectEL,
          meta: {
            title: 'EL Dashboard'
          }
         },
         {
          path: '/selectCMS',
          name: 'cmsselect',
          component: SelectCMS,
          meta: {
            title: 'EMS Dashboard'
          }
         },
         {
          path: '/timetable',
          name: 'timetable',
          component: Timetable,
          meta: {
            title: 'TimeTable'
          }
         },
         {
          path: '/attend',
          name: 'attendance',
          component: Attendance,
          meta: {
            title: 'Attendance'
          }
         },
         {
          path: '/examresult',
          name: 'examresult',
          component: ExamResult,
          meta: {
            title: 'Exam Result'
          }
         },
         {
          path: '/fees',
          name: 'fees',
          component: Fees,
          meta: {
            title: 'Fees'
          }
         },
        {
          path: '/select',
          name: 'programselect',
          component: ProgramSelect,
          meta: {
            title: 'Program Select'
          }
        },
        {
          path: '/mcqsubject',
          name: 'mcqsubject',
          component: MCQSubject,
        },
        {
          path: '/mcqtype',
          name: 'mcqtype',
          component: MCQTypeSelect,
          meta: {
            title: 'MCQ\'s'
          }
        },
        {
          path: '/videosubject',
          name: 'videosubject',
          component: VideosSubject,
          meta: {
            title: 'Video Learning'
          }
        },
        {
          path: '/videotopic',
          name: 'videotopic',
          component: VideosTopic,
          meta: {
            title: 'Video Learning'
          }
        },
        {
          path: '/progress',
          name: 'progress',
          component: Progress,
          meta: {
            title: 'Progress'
          }
        },
        {
          path: '/pastpapers',
          name: 'pastpapers',
          component: PastPapers,
          meta: {
            title: 'Past Papers'
          }
        },
        {
          path: '/winners',
          name: 'winners',
          component: Winners,
        },
        {
          path: '/*',
          name: 'notfound',
          component: PageNotFound,
          meta: {
            title: '404'
          }
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
   // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => {
    if (el.parentNode)
      el.parentNode.removeChild(el)}
    );
  

  // Skip rendering meta tags if there are none.
  if(nearestWithMeta){

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(tag => document.head.appendChild(tag));
  }
  const auth = new AuthService();
  const footer = document.getElementById('footer');
  const name = to.name;
  const fbNotAccess = ['progress', 'profile', 'home'];

  if (footer !== null && name !== undefined && name !== 'progress' && name !== null){
    footer.className = name;
  }

  if (!auth.session){
    localStorage[config.isPre] = null;
  }
    if (to.name !== 'home' && to.name !== 'download' && to.name !== 'test-class-select' && to.name !== 'test-paper' && to.name !== 'winners') {
      if (auth.session === null || auth.session.userId === null) {
        next('/');
      }
    } else {
      if (to.name == 'test-class-select' || to.name == 'test-paper' || to.name == 'winners') {
        next();
      }
      else if (auth.session !== null && auth.session.userId !== null) {
        if (localStorage[config.isPre] && JSON.parse(localStorage[config.isPre]))
          next('/pre-module');
        else 
          next('/selectApp');
      }
    }

  next();
});


router.afterEach(function(transition) {
  window.scrollTo(0, 0);
});

export default router;
